import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #423f9a;
  height: 32px;
  width: 32px;
`
export const LayersIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 32" className={className}>
      <path d="M16.4992 26.5281L5.57617 18.0411L7.21217 16.7848L16.4992 23.9744L25.7862 16.7848L27.4222 18.0411L16.4992 26.5281ZM16.4992 20.6154L5.57617 12.1284L16.4992 3.64111L27.4222 12.1284L16.4992 20.6154ZM16.4992 18.0618L24.1658 12.1284L16.4992 6.19511L8.83251 12.1284L16.4992 18.0618Z" />
    </Svg>
  )
}
